import * as React from 'react';
import { Drawer } from 'antd';
import styled from 'styled-components';
import { FilterOutlined } from '@ant-design/icons';

import { breakpoints, colors } from 'theme/variables';

const StyledDrawer = styled(Drawer)`
    &&& .ant-drawer-content-wrapper {
        box-shadow: -12px 0 40px rgba(0, 0, 0, 0.1);
        width: 90vw !important;
        max-width: 480px;

        ${breakpoints.small} {
            width: 380px !important;
        }

        ${breakpoints.medium} {
            width: 440px !important;
        }

        ${breakpoints.desktop} {
            width: 480px !important;
        }
    }

    &&& .ant-drawer-header {
        padding: 16px;
        border-bottom: 1px solid #edf0f4;
        background: #f8f9fb;

        ${breakpoints.small} {
            padding: 20px 24px;
        }
    }

    &&& .ant-drawer-title {
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 1rem;
        color: ${colors.secondaryColor};
        display: flex;
        align-items: center;
        gap: 10px;
    }

    &&& .ant-drawer-close {
        color: #8c95a6;
        font-size: 16px;

        &:hover {
            color: ${colors.secondaryColor};
        }
    }

    &&& .ant-drawer-body {
        padding: 0;
        overflow-y: auto;

        form {
            padding: 16px;
            max-width: 100%;

            ${breakpoints.small} {
                padding: 20px 24px;
            }
        }

        h2 {
            display: none;
        }
    }
`;

const TitleIcon = styled(FilterOutlined)`
    font-size: 18px;
    color: ${colors.primary};
`;

interface FilterDrawerProps {
    visible: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
}

export const FilterDrawer: React.FC<FilterDrawerProps> = ({
    visible,
    onClose,
    title = 'All Filters',
    children,
}) => (
    <StyledDrawer
        title={
            <>
                <TitleIcon />
                {title}
            </>
        }
        placement="right"
        width="100%"
        onClose={onClose}
        visible={visible}
        destroyOnClose
    >
        {/*
         * The drawer portals to document.body, but React synthetic events still
         * bubble up the React tree. Without this guard the filter form's `submit`
         * event reaches the surrounding page form (e.g. the Assign-employees form
         * on Edit Projects), triggering its required-field validation and a
         * spurious "Please update the data you have entered" error (CFS-1065).
         */}
        <div onSubmit={(event) => event.stopPropagation()}>{children}</div>
    </StyledDrawer>
);
